var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createStore } from '../../util/createStore';
import { useEffect } from 'react';
export var ThemeColor;
(function (ThemeColor) {
    ThemeColor["LIGHT"] = "light";
    ThemeColor["DARK"] = "dark";
})(ThemeColor || (ThemeColor = {}));
var useStore = createStore({
    color: localStorage.getItem('useTheme.color') || ThemeColor.DARK,
}).useStore;
export function useTheme() {
    var _a = useStore(), state = _a[0], setState = _a[1];
    function setColor(color) {
        document.documentElement.setAttribute('theme', color);
        localStorage.setItem('useTheme.color', color);
    }
    return __assign(__assign({}, state), { isDark: state.color === ThemeColor.DARK, isLight: state.color === ThemeColor.LIGHT, useRegister: function () {
            useEffect(function () {
                if (state.color) {
                    setColor(state.color);
                }
            }, [state.color]);
        },
        toggleColor: function () {
            setState(function (state) {
                state.color = state.color === ThemeColor.DARK ? ThemeColor.LIGHT : ThemeColor.DARK;
            });
        } });
}
